// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import TimorLeste from '../_raw/flag/icon_flag_timor_leste.png';

export default () => <img src={TimorLeste} alt="TimorLeste" />;
